<template>
	<div class="drawerBody">
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
			<el-dialog :title="titmc" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="12">
						<addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
					</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="隐患类型" prop="yhlx">
          		<el-select :disabled="states=='ck'" v-model.trim="ruleForm.yhlx" class="from-el-input" placeholder="隐患类型">
          			<el-option v-for="(item,i) in yhlxlist" :key="i" :label="item.name" :value="item.code">
          			</el-option>
          		</el-select>
          	</el-form-item>
          </el-col>
				</el-row>
        <el-row>
          <el-col :span="12">
          	<el-form-item type="type" label="隐患等级" prop="yhlx">
          		<el-select :disabled="states=='ck'" v-model.trim="ruleForm.yhdj" class="from-el-input" placeholder="隐患等级">
          			<el-option v-for="(item,i) in yhdjlist" :key="i" :label="item.name" :value="item.code">
          			</el-option>
          		</el-select>
          	</el-form-item>
          </el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="整改情况" prop="zgqk">
              <el-select :disabled="states=='ck'" v-model.trim="ruleForm.zgqk" class="from-el-input" placeholder="隐患整改情况">
              	<el-option v-for="(item,i) in zglist" :key="i" :label="item.name" :value="item.code">
              	</el-option>
              </el-select>
          	</el-form-item>
          </el-col>
        </el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item type="type" label="登记人" prop="djr">
							<el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="登记人" v-model.trim="ruleForm.djr"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item type="type" label="登记日期" prop="djrq">
							<el-date-picker :disabled="states=='ck'" v-model.trim="ruleForm.djrq" type="date" class="from-el-input-item" value-format="yyyy-MM-dd" placeholder="登记日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :span="24">
					<el-form-item type="type" label="隐患描述" prop="yhms">
						<el-input :disabled="states=='ck'" type="textarea" v-model.trim="ruleForm.yhms" class="from-el-input" maxlength="150" :rows="4" placeholder="隐患描述">
						</el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData.length!=0">
						<div class="titna">
							<span class="addSpan">图片</span>
						</div>
						<div class="tp" v-if="states=='xz'||states=='bj'">
							<el-upload action :auto-upload="false" list-type="picture-card" :on-preview="imghandl" :on-change="imgchanges" :on-remove="imghandleRemove">
							</el-upload>
				      <div class='fujian fujians' v-if="ImgfileListData.length!=0">
				        <ul class="fjhxlist">
				          <li v-for="(item,i) in ImgfileListData" :key="i">
				            <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				            <div class="names cz">
				              <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				              <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'tp')"
				                class="btnmargin"></el-button>
				            </div>
				          </li>
				        </ul>
				      </div>
						</div>
						<div class="tp tps" v-if="states=='ck' && ImgfileListData.length!=0">
							<ul class="qrtpul">
								<li class v-for="(item,i) in ImgfileListData" :key="i">
									<img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
								</li>
							</ul>
						</div>
					</el-col>
				</el-row>
				<el-row v-if="states=='xz'||states=='bj'" style="margin-top: 10px;">
				  <el-col :span="24">
				    <div class="titna">
				      <span class="addSpan">附件</span>
				    </div>
				    <div class='fujian'>
				      <el-upload class="upload-demo" drag action="" multiple :on-remove="handleRemove" :on-change='changes'
				        :file-list="fileList" :limit="5" :auto-upload='false'>
				        <i class="el-icon-upload"></i>
				        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				      </el-upload>
				      <div class='fujian fujians' v-if="filetabledata.length!=0">
				        <ul class="fjhxlist">
				          <li v-for="(item,i) in filetabledata" :key="i">
				            <div class="names" style="text-align: left;">{{item.sourceName}}</div>
				            <div class="names cz">
				              <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
				              <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'fj')"
				                class="btnmargin"></el-button>
				            </div>
				          </li>
				        </ul>
				      </div>
				    </div>
				  </el-col>
				</el-row>
        <el-row v-if="states=='ck' && filetabledata.length!=0" style="margin-top: 10px;">
          <el-col :span="24">
            <div class="titna">
              <span class="addSpan">附件</span>
            </div>
            <div class='fujian'>
              <ul class="fjhxlist">
                <li v-if="filetabledata.length==0" style='width:100%;height:80px;line-height: 80px;color:#ccc'>暂无附件,请上传！</li>
                <li v-for="(item,i) in filetabledata" :key="i" v-if="filetabledata.length!=0">
                  <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                  <div class="names cz">
                    <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                    <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'fj')"
                      class="btnmargin"></el-button>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
				<el-row class="rowTop" style="margin-top:15px">
					<el-col :span="8">
						<el-form-item type="type" label="经度坐标" prop="lats">
							<el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="经度坐标" v-model.trim="ruleForm.lngs"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item type="type" label="纬度坐标" prop="lats">
							<el-input :disabled="states=='ck'" type="type" class="from-el-input" placeholder="纬度坐标" v-model.trim="ruleForm.lats"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8" v-if="mystate[1]!='homeyh'">
						<el-button size="mini" type="primary" @click="supclick()" style="float: right;margin-left: 20px; margin-top: 10px;">点击拾取位置</el-button>
					</el-col>
				</el-row>
				<el-row class="rowTop">
					<el-col style="width: 100%;height: 400px;">
						<supgiscomponent :mapChliddata="mapchliddata" :mapClickstate="mapclickstate" @changeData="changeData" @clickData="clickData" :latlngs="latlngs"></supgiscomponent>
					</el-col>
				</el-row>
				<span slot="footer" class="dialog-footer">
					<el-form-item>
					  <el-button v-if="states !== 'ck'" @click="cancel()" type="warning">取 消</el-button>
					  <el-button v-if="states == 'xz'" type="success" @click="deteRmine('ruleForm','xz')">保 存</el-button>
					  <el-button v-if="states == 'bj'" type="success" @click="deteRmine('ruleForm','bj')">保 存</el-button>
					</el-form-item>
				</span>
			</el-dialog>
		</el-form>
		<!--弹出框-->

    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
	</div>
</template>

<script>
  import { ydbjbxxQuery, yhglSave, yhglUpdate, dictioninfo, deleteFile } from "@/api/api";
	import supgiscomponent from "@/components/visualization/supgisComponent.vue"
  import addressTree from '@/components/mangement/popupaddressTree.vue'
  import axios from 'axios'
	export default {
		props: {
			mystate: Array,
		},
		data() {
			return {
        urlsss: '/userApi/minio/updateFileMulti/',
        downloadUrl: "/userApi/minio/downloadFile/",
        states: '',
				dialogVisible: true,
        currentData: '',
				titmc: '新建隐患',
				ruleForm: {
					ydbName: '',
          ydbCode: '',
					yhlx: '',
					yhdj: '',
          zgqk: '',
					djr: '',
					djrq: '',
					yhms: '',
					lats: '',
					lngs: '',
				},
				rules: {
          ydbName: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					yhlx: [
						{ required: true, message: '请输入必填项', trigger: 'change' }
					],
					yhdj: [
						{ required: true, message: '请输入必填项', trigger: 'change' }
					],
          zgqk: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					djr: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					djrq: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					yhms: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					lats: [
						{ required: true, message: '请输入必填项', trigger: 'change' }
					],
          lngs: [
          	{ required: true, message: '请输入必填项', trigger: 'change' }
          ]
				},
        zglist: [], //隐患整改情况
				yhlxlist: [], // 隐患类型
				yhdjlist: [], // 隐患等级

				imgfileList: [],	// 图片
        ImgfileListData: [], // 修复前图片回显
        imgfileUrl: '',
				dialogImageUrl: '', // 图片上传用到
        imgdialogVisible: false,

				fileList: [], // 附件
        filetabledata: [], // 回显附件
        fileUrl: '',
        
        latlngs: null,

				latlngtext: '',
        mapchliddata: null,
				mapclickstate: false,
			}
		},
		created() {

		},
		computed: {

		},
		components: {
      addressTree,
			supgiscomponent
		},
		methods: {
      //获取隐患类型数字字典
      getyhlxinfo() {
        let params = {
          type: 'yhgl',
          code: 'type'
        };
        dictioninfo(params).then((res) => {
          this.yhlxlist = res.data;
        })
      },
      //获取隐患等级数字字典
      getyhdjinfo() {
        let params = {
          type: 'yhgl',
          code: 'level'
        };
        dictioninfo(params).then((res) => {
          this.yhdjlist = res.data;
        })
      },
      //获取隐患整改情况数字字典
      getyhzginfo() {
        let params = {
          type: 'yhgl',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.zglist = res.data;
        })
      },
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbName = res.data[0].ydbName;
          }
        })
      },
      treeClose(){
      },
      objdata(data) {
      	let params = {
      		ydbCode:data.ydbCode
      	};
      	this.list(params);
      },
			changeData(data) {
				this.ruleForm.lats = data.properties.LAT;
				this.ruleForm.lngs = data.properties.LON;
				this.latlngtext = this.ruleForm.lats + ',' + this.ruleForm.lngs;
			},
			clickData(data) {
				this.ruleForm.lats = data.latlng.lat;
				this.ruleForm.lngs = data.latlng.lng;
				this.latlngtext = this.ruleForm.lats + ',' + this.ruleForm.lngs;
			},
			getNowTime() {
				let date = new Date()
				let y = date.getFullYear()
				let m = date.getMonth() + 1
				let d = date.getDate()
				this.ruleForm.djrq = y + '-' + m + '-' + d
			},
			deteRmine(formName, states) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            //照片Url
            if (this.imgfileList.length != 0) {
              let formData = new FormData();
              this.imgfileList.forEach((el, index) => {
                formData.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData, config).then(res => {
                if(res.data.code === 200) {
                  this.imgfileUrl = res.data.data;
                }
              }).catch(err => {});
            }
            //附件
            if (this.fileList.length != 0) {
              let formData1 = new FormData();
              this.fileList.forEach((el, index) => {
                formData1.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });

              axios.post(this.urlsss, formData1, config).then(res => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "success",
                  });
                  this.fileUrl = res.data.data;
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.data.message,
                    type: "warning",
                  });
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbName: _this.ruleForm.ydbName, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbYhlx: _this.ruleForm.yhlx, //隐患类型
                  ydbYhdj: _this.ruleForm.yhdj, //隐患等级
                  status: _this.ruleForm.zgqk, //整改情况
                  ydbDjr: _this.ruleForm.djr, //登记人
                  ydbDjqr: _this.ruleForm.djrq, //登记日期
                  ydbYhms: _this.ruleForm.yhms, //隐患描述
                  ydbJingDu: _this.ruleForm.lngs, //经度
                  ydbWeiDu: _this.ruleForm.lats, //纬度
                  ydbTuPian: _this.imgfileUrl, //照片
                  ydbShiPin: _this.fileUrl, //附件
                };
                yhglSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let yhlx,yhdj,zgqk;
                if (_this.ruleForm.yhlx === '工程隐患') {
                  yhlx = 0;
                } else if (_this.ruleForm.yhlx === '设备隐患') {
                  yhlx = 1;
                } else if (_this.ruleForm.yhlx === '设施隐患') {
                  yhlx = 2;
                } else {
                  yhlx = 3;
                }
                if (_this.ruleForm.yhdj === '特大影响') {
                  yhdj = 0;
                } else if (_this.ruleForm.yhdj === '重大影响') {
                  yhdj = 1;
                } else if (_this.ruleForm.yhdj === '较大影响') {
                  yhdj = 2;
                } else {
                  yhdj = 3;
                }
                if (_this.ruleForm.zgqk === '已整改') {
                  zgqk = 0;
                } else {
                  zgqk = 1;
                }
                let params = {
                 ydbName: _this.ruleForm.ydbName, //淤地坝名称
                 ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                 ydbYhlx: yhlx, //隐患类型
                 ydbYhdj: yhdj, //隐患等级
                 status: zgqk, //整改情况
                 ydbDjr: _this.ruleForm.djr, //登记人
                 ydbDjqr: _this.ruleForm.djrq, //登记日期
                 ydbYhms: _this.ruleForm.yhms, //隐患描述
                 ydbJingDu: _this.ruleForm.lngs, //经度
                 ydbWeiDu: _this.ruleForm.lats, //纬度
                 ydbTuPian: _this.imgfileUrl, //照片
                 ydbShiPin: _this.fileUrl, //附件
                  id: _this.row.id
                };
                if (params.ydbTuPian === '') {
                  params.ydbTuPian = null;
                }
                if (params.ydbShiPin === '') {
                  params.ydbShiPin = null;
                }
                yhglUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 500)
          }
        });
			},

			cancel() {
				this.dialogVisible = false;
				this.$emit('getcancel', { 'dialogVisible': this.dialogVisible });
			},
			handleClose() {
				this.dialogVisible = false;
				this.$emit('getcancel', { 'dialogVisible': this.dialogVisible });
			},
			supclick() {
				this.mapclickstate = true;
			},
      DownloadFile(index, row) {
      	// 下载文件
        window.open(this.downloadUrl + row.fileName);
      },
      deletesfile(index, row, type) {
      	// 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
            if(type === 'tp') this.ImgfileListData.splice(index, 1);
            if(type === 'fj') this.filetabledata.splice(index, 1);
        	}
        })
      },
      imgzoom(url) {
        window.open(url);
      },
      imghandl(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },
      imghandleRemove(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.imgfileList.length; i++) {
          if (file.name == this.imgfileList[i].name) {
            this.imgfileList.splice(this.imgfileList[i], 1);
          }
        }
      },
      imgchanges(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.imgfileList.push(file.raw)
      	}
      },
      handleRemove(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.fileList.length; i++) {
          if (file.name == this.fileList[i].name) {
            this.fileList.splice(this.fileList[i], 1);
          }
        }
      },
      changes(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.fileList.push(file.raw)
      	}
      },
		},
		mounted() {
      this.getyhlxinfo();
      this.getyhdjinfo();
      this.getyhzginfo();
      this.getNowTime();

      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj' || this.states == 'ck') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbName = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.djr = this.mystate[1].ydbDjr; //登记人
        this.ruleForm.djrq = this.mystate[1].ydbDjqr; //登记日期
        this.ruleForm.yhms = this.mystate[1].ydbYhms; //隐患描述
        this.ruleForm.lngs = this.mystate[1].ydbJingDu; //经度
        this.ruleForm.lats = this.mystate[1].ydbWeiDu; //纬度

        this.ImgfileListData = this.mystate[1].ydbTuPian;
        for (let i=0; i<this.ImgfileListData.length; i++) {
          this.ImgfileListData[i].url = this.downloadUrl + this.ImgfileListData[i].fileName;
        }
        this.filetabledata = this.mystate[1].ydbShiPin;
        
        this.latlngs = {lat: this.ruleForm.lats, lng: this.ruleForm.lngs};

        if (this.mystate[1].ydbYhlx === 0) {
          this.ruleForm.yhlx = '工程隐患';
        } else if (this.mystate[1].ydbYhlx === 1) {
          this.ruleForm.yhlx = '设备隐患';
        } else if (this.mystate[1].ydbYhlx === 2) {
          this.ruleForm.yhlx = '设施隐患';
        } else {
          this.ruleForm.yhlx = '其他隐患';
        }

        if (this.mystate[1].ydbYhdj === 0) {
          this.ruleForm.yhdj = '特大影响';
        } else if (this.mystate[1].ydbYhdj === 1) {
          this.ruleForm.yhdj = '重大影响';
        } else if (this.mystate[1].ydbYhdj === 2) {
          this.ruleForm.yhdj = '较大影响';
        } else {
          this.ruleForm.yhdj = '一般影响';
        }

        if (this.mystate[1].status === 0) {
          this.ruleForm.zgqk = '已整改'; //状态
        } else {
          this.ruleForm.zgqk = '未整改'; //状态
        }
      }
		}
	}
</script>
<style scoped>
  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  .tp {
  	width: calc(100% - 122px);
  	float: left;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 10px;
  }

  .fujian {
    width: -webkit-calc(100% - 102px);
    width: -moz-calc(100% - 102px);
    width: calc(100% - 102px);
  	float: left;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 10px;
  }

	.el-dialog__body {
		max-height: 600px;
	}

	>>>.el-dialog__body {
		max-height: 500px;
	}

	>>>.el-dialog {
		width: 1000px;
	}

	>>>.el-input.is-disabled .el-input__inner {
		color: #606266;
	}

	>>>.el-textarea.is-disabled .el-textarea__inner {
		color: #606266;
	}
</style>
